import { CircularProgress, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  loadingContainer: props => ({
    display: 'flex',
    justifyContent: props.justifyContent,
    alignItems: props.alignItems
  })
});

const DelayedSpinner = ({ delay = 500, size = 55, justifyContent = 'center', alignItems = 'center', color, inline }) => {
  const classes = useStyles({ justifyContent, alignItems });
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), delay);

    return () => clearTimeout(timer);
  });

  return (
    showSpinner && (
      inline ? <CircularProgress size={size} color={color || 'primary'} />
        : <Container className={classes.loadingContainer}>
          <CircularProgress size={size} color={color || 'primary'} />
        </Container>
    )
  );
};

/*DelayedSpinner.defaultProps = {
  delay: 1000,
  size: 55,
  justifyContent: 'center',
  alignItems: 'center'
};*/

export default DelayedSpinner;
